import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";


export default function HomeMap() {

  return (
    <>
      <section className="global-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="global-text heading-gap">
                <span className="subtitle">MOBILITY TMS PLATFORM</span>
                <h2 className="heading">See intelligent logistics in motion</h2>
                <div className="global-btn">
                  <Link className="theme-btn" to="/contact-us"> <span>Book a demo</span></Link>
                  <Link className="theme-btn trasparent-btn" to="/contact-us"> <span>Explore platform</span></Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className='col-md-12'>
              <div className="map-image">
                <img src="/assets/gif-video/earth-gif.gif" alt="Map" className="img-responsive" loading="lazy" />
              </div>
              {/* <iframe
                src="https://lottie.host/embed/f173b9b3-c8ff-43a5-86dd-f5de1cdc4186/BI4lu9uezN.lottie"
                 style={{
    border: "none",
    width: "100%",   // full width
    height: "450px", // set height
    display: "block"
  }}
                title="Lottie Animation"
              ></iframe>  */}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
